<template>
    <b-modal :modal-class="`modal-primary modal-min-btn`"
             v-model="isOpen"
             title="Copia garanzie da:"
             @cancel="onCancel"
             @ok="onOk"
             @show="onShow"
             ok-title="Copia"
             centered
             ref="modal">
        <div>
            <af-select v-model="value"
                       multiple
                       search-nested
                       valueFormat="object"
                       :options="options">
            </af-select>
        </div>
    </b-modal>
</template>


<script>
import modalDialog from "@/plugins/dialogs/mixins/modalDialog";
import AfSelect from "@/components/inputs/AfSelect";
import store from "./store";


export default {
    name: 'SelectProvincesDialog',
    mixins: [modalDialog],
    components: {AfSelect},
    props: {},
    data() {
        return {
            value: null,
        }
    },
    computed: {
        options() {
            return store.provincesTree
        }
    },
    methods: {
        onShow() {
            this.value = null
        }
    },
}
</script>
